import { useEffect, useState } from "react";

export const useAuthInit = () => {
  const [isAuthInitialized, setIsAuthInitialized] = useState(false);
  const [isAuthInitSuccess, setIsAuthInitSuccess] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const response = await fetch(`${window.gxApiConnection}/api/v5/auth/init`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        });
        setIsAuthInitSuccess(response.ok && response.status === 200);
      } finally {
        setIsAuthInitialized(true);
      }
    })();
  }, [setIsAuthInitialized, setIsAuthInitSuccess]);

  return { isAuthInitialized, isAuthInitSuccess };
};
